import * as React from "react"
import PropTypes from "prop-types"
// import { Link } from "gatsby"
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'
// import { faInstagram } from '@fortawesome/free-brands-svg-icons'
// import { OffCanvas } from './offCanvas'
import { NavItems } from './navItems'


const Header = ({ siteTitle }) => (
  <header>
    <div className="container">
      <div className="left">
        <NavItems />
      </div>
      {/* <div className="right">
        <OffCanvas />
      </div> */}

    </div>

  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
